import { useEffect } from "react";

const Iugu = {
  impl() {

    if (!window.Iugu) {
      console.log("IUGU não foi renderizado ainda!")
    }

    return window.Iugu;
  },
  setAccountToken(token) {
    this.impl().setAccountID(token);
  },
  setTestMode(mode) {
    this.impl().setTestMode(mode);
  },
  createPaymentToken(form, throwOnError = false) {
    return new Promise((resolve, reject) => {
      this.impl().createPaymentToken(form, (response) => {
        if (response.errors && throwOnError) {
          return reject(response);
        }

        resolve(response);
      });
    });
  }
};

export default function useIugu(accountId) {
  useEffect(() => {
    if (document.getElementById("iugu-script") && window.Iugu) {
      Iugu.setAccountToken(accountId);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://js.iugu.com/v2";
    script.id = "iugu-script";

    script.onload = () => {
      Iugu.setAccountToken(accountId);
      if(process.env.REACT_APP_IS_IUGU_ON_TEST_MODE === "true") {
        Iugu.setTestMode(true);
      }
    };

    document.head.appendChild(script);

    return () => document.getElementById("iugu-script").remove();
  }, [accountId]);

  return Iugu;
}
